import { BeeyLocale } from 'libs/locales/locale';
export const getDefaultSpeaker = (speakerData, localization) => {
    var _a;
    const locKey = localization !== null && localization !== void 0 ? localization : speakerData.neutralData.defaultLocalisation;
    const defaultLocalization = speakerData.localizations[locKey];
    const { nameVariants, defaultVariantIndex } = defaultLocalization;
    const defaultVariant = nameVariants[defaultVariantIndex];
    return {
        firstName: defaultVariant.firstName !== '' ? defaultVariant.firstName : null,
        lastName: defaultVariant.lastName,
        role: (_a = defaultVariant.roles[defaultVariant.defaultRoleIndex]) !== null && _a !== void 0 ? _a : null,
    };
};
export const toSpeakerRows = (speakers, languages) => speakers.flatMap((speaker) => {
    const allLocalizationKeys = Object.keys(speaker.localizations);
    const localizationKeys = languages !== undefined && languages.length > 0
        ? allLocalizationKeys.filter((key) => languages.some((l) => l.code === key))
        : allLocalizationKeys;
    const defaultLocKey = speaker.neutralData.defaultLocalisation;
    const defaultLoc = speaker.localizations[defaultLocKey];
    if (defaultLoc === undefined) {
        return [];
    }
    const defaultVariant = defaultLoc.nameVariants[defaultLoc.defaultVariantIndex];
    if (defaultVariant === undefined) {
        return [];
    }
    const totalVariantCount = localizationKeys
        .reduce((sum, key) => sum + speaker.localizations[key].nameVariants.length, 0);
    const localizationRows = localizationKeys.map((locKey) => {
        const loc = speaker.localizations[locKey];
        const { nameVariants, defaultVariantIndex } = loc;
        const defVariant = nameVariants[defaultVariantIndex];
        const beeyLocale = BeeyLocale.fromCode(locKey);
        const variantRows = nameVariants.map((variant, idx) => ({
            key: `${speaker.neutralData.uniqueId}-${locKey}-${idx}`,
            uniqueId: speaker.neutralData.uniqueId,
            rowType: 'variant',
            firstName: variant.firstName !== '' ? variant.firstName : null,
            lastName: variant.lastName,
            roles: variant.roles,
            defaultRoleIndex: variant.defaultRoleIndex,
            locale: beeyLocale,
            isDefault: idx === defaultVariantIndex,
            lastEdited: '',
            variantCount: 0,
            imageBase64: '',
        }));
        return {
            key: `${speaker.neutralData.uniqueId}-${locKey}`,
            uniqueId: speaker.neutralData.uniqueId,
            rowType: 'localization',
            firstName: defVariant.firstName !== '' ? defVariant.firstName : null,
            lastName: defVariant.lastName,
            roles: defVariant.roles,
            defaultRoleIndex: defVariant.defaultRoleIndex,
            locale: beeyLocale,
            isDefault: locKey === defaultLocKey,
            lastEdited: speaker.neutralData.lastEdited,
            variantCount: nameVariants.length,
            imageBase64: speaker.neutralData.imageBase64,
            speakerIdActive: loc.speakerIdActive,
            children: nameVariants.length >= 1 ? variantRows : undefined,
        };
    });
    if (languages !== undefined && languages.length === 1) {
        return localizationRows;
    }
    return [{
            key: speaker.neutralData.uniqueId,
            uniqueId: speaker.neutralData.uniqueId,
            rowType: 'speaker',
            firstName: defaultVariant.firstName !== '' ? defaultVariant.firstName : null,
            lastName: defaultVariant.lastName,
            roles: defaultVariant.roles,
            defaultRoleIndex: defaultVariant.defaultRoleIndex,
            locale: null,
            isDefault: false,
            lastEdited: speaker.neutralData.lastEdited,
            variantCount: totalVariantCount,
            imageBase64: speaker.neutralData.imageBase64,
            speakerIdActive: defaultLoc.speakerIdActive,
            children: localizationRows,
        }];
});
